import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import VendorHeader from "./../component/VendorHeader";
import VendorFooter from "./../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";
import { NotificationManager } from "react-notifications";

const icon1 = require("./../assets/img/dashboard-icon.svg").default;
const icon2 = require("./../assets/img/info-icon.svg").default;
const icon3 = require("./../assets/img/app-icon.svg").default;
const icon4 = require("./../assets/img/payment-icon.svg").default;
const icon5 = require("./../assets/img/store-icon.svg").default;
const icon6 = require("./../assets/img/list-icon.svg").default;
const icon7 = require("./../assets/img/order-icon.svg").default;
const icon8 = require("./../assets/img/plan-icon.svg").default;
const icon9 = require("./../assets/img/logout-icon.svg").default;
const deleteIcon = require("./../assets/img/delete-icon.svg").default;
const uploadBtn = require("./../assets/img/search-btn.svg").default;
const bulletIcon = require("./../assets/img/bullet.svg").default;

const VendorRequestPriceListing = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const navigate = useNavigate();

  const [loading, setLoading] = useState();
  const [allDetails, setAllDetails] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [customerNo, setCustomerNo] = useState("");
  const [savingCustomerNo, setSavingCustomerNo] = useState(false);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}stores/price-requests`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAllDetails(responseData?.data);
      } else {
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const onStatusChange = async (id, statusValue) => {
    try {
      const response = await fetch(`${API_BASE_URL}stores/price-requests/${id}`, {
        method: "POST",
        body: JSON.stringify({ is_granted: statusValue }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        NotificationManager.success(responseData?.msg);
        let tempArray = [...allDetails];
        let index = tempArray.findIndex(item => parseInt(item?.id) === parseInt(id));
        tempArray[index].is_granted = statusValue;
        setAllDetails(tempArray);
      } else {
        NotificationManager.success(responseData?.msg);
      }
    } catch (error) { }
  };

  const openModal = (request) => {
    setSelectedRequest(request);
    setCustomerNo(request?.customer_no || "");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedRequest(null);
    setCustomerNo("");
  };

  const saveCustomerNo = async () => {
    if (!selectedRequest) return;

    setSavingCustomerNo(true);
    try {
      const response = await fetch(`${API_BASE_URL}stores/price-requests/${selectedRequest.id}`, {
        method: "POST",
        body: JSON.stringify({ customer_no: customerNo }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        NotificationManager.success(responseData?.msg || "Customer number updated successfully");
        let tempArray = [...allDetails];
        let index = tempArray.findIndex(item => parseInt(item?.id) === parseInt(selectedRequest.id));
        tempArray[index].customer_no = customerNo;
        setAllDetails(tempArray);
        closeModal();
      } else {
        NotificationManager.error(responseData?.msg || "Failed to update customer number");
      }
    } catch (error) {
      console.error("Error saving customer number:", error);
      NotificationManager.error("Error saving customer number");
    } finally {
      setSavingCustomerNo(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchOrders();
    }
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />

        <div className="rightSide rightTop">
          <h2>{langJson?.requests}</h2>

          <div className="prdtTable">
            <table>
              <tr>
                <th>{langJson?.requestedcompanyname}</th>
                <th>{langJson?.fullname}</th>
                <th>{langJson?.telephone}</th>
                <th>{langJson?.email}</th>
                <th>{langJson?.address}</th>
                <th>Customer No</th>
                <th>{langJson?.action}</th>
              </tr>
              {allDetails?.length > 0 ? (
                allDetails?.map((item, index) => (
                  <tr key={index}>
                    <td>{item?.company_name}</td>
                    <td>{item?.name}</td>
                    <td>{item?.phone}</td>
                    <td>{item?.email}</td>
                    <td>{item?.full_address}</td>
                    <td>{item?.customer_no || "-"}</td>
                    <td style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                      <button className="btn viewBtn" onClick={() => openModal(item)}>
                        View
                      </button>
                      {parseInt(item?.is_granted) === 1 ? (
                        <button className="btn declineBtn" onClick={() => onStatusChange(item?.id, 0)}>
                          Decline
                        </button>
                      ) : (
                        <button className="btn acceptBtn" onClick={() => onStatusChange(item?.id, 1)}>
                          Accept
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : !loading ? (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center" }}>
                    {langJson?.noresultsfound}
                  </td>
                </tr>
              ) : null}
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && selectedRequest && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "30px",
            maxWidth: "600px",
            width: "90%",
            maxHeight: "80vh",
            overflowY: "auto",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          }}>
            <h3 style={{ marginTop: 0, marginBottom: "20px" }}>Customer Information</h3>

            <div style={{ marginBottom: "15px" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>Company Name</label>
              <p style={{ margin: 0, color: "#475168" }}>{selectedRequest?.company_name || "-"}</p>
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>Full Name</label>
              <p style={{ margin: 0, color: "#475168" }}>{selectedRequest?.name || "-"}</p>
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>Email</label>
              <p style={{ margin: 0, color: "#475168" }}>{selectedRequest?.email || "-"}</p>
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>Telephone</label>
              <p style={{ margin: 0, color: "#475168" }}>{selectedRequest?.phone || "-"}</p>
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>Address</label>
              <p style={{ margin: 0, color: "#475168" }}>{selectedRequest?.full_address || "-"}</p>
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>Tax ID</label>
              <p style={{ margin: 0, color: "#475168" }}>{selectedRequest?.tax_id || "-"}</p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "block", fontWeight: "600", marginBottom: "5px" }}>
                Customer No <span style={{ color: "#999", fontSize: "12px" }}>(Optional)</span>
              </label>
              <input
                type="text"
                value={customerNo}
                onChange={(e) => setCustomerNo(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #DEE4EF",
                  borderRadius: "4px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                }}
                placeholder="Enter customer number"
              />
            </div>

            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                onClick={closeModal}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={saveCustomerNo}
                disabled={savingCustomerNo}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#475168",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: savingCustomerNo ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  opacity: savingCustomerNo ? 0.6 : 1,
                }}
              >
                {savingCustomerNo ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      <VendorFooter />
    </div>
  );
};

export default VendorRequestPriceListing;
